import { gql } from "@apollo/client"
export const POINTS = gql`
query Points($where: PointWhereInput, $orderBy: OrderByInput, $limit: Int, $skip: Int) {
    points(where: $where, orderBy: $orderBy, limit: $limit, skip: $skip) {
      total
      data {
        point
        money
        type
        createdAt
        note
      }
    }
  }`;